import React from 'react';
import { Form, Input, Modal } from 'antd';
import type { FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import { AttributeOptionsEditor } from './AttributeOptionsEditor';

interface CreateAttributeModalProps {
  open: boolean;
  onOk: () => Promise<void>;
  onCancel: () => void;
  form: FormInstance;
  loading?: boolean;
}

export const CreateAttributeModal: React.FC<CreateAttributeModalProps> = ({
  open,
  onOk,
  onCancel,
  form,
  loading,
}) => {
  const { t } = useTranslation('crops');
  return (
    <Modal
      title={t('attributes.createFarmTitle')}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={t('common:actions.create')}
      cancelText={t('common:actions.cancel')}
      confirmLoading={loading}
      width={600}
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          label={t('attributes.name')}
          name="name"
          rules={[{ required: true, message: t('details.createAttributeModal.nameRequired') }]}
        >
          <Input placeholder={t('attributes.namePlaceholder')} />
        </Form.Item>
        <Form.Item label={t('common:labels.description')} name="description">
          <Input.TextArea rows={2} placeholder={t('attributes.descriptionPlaceholder')} />
        </Form.Item>
        <Form.List name="options">
          {(fields, operations) => (
            <AttributeOptionsEditor
              fields={fields}
              operations={operations}
              helperText={t('attributes.options.helperOptional')}
              emptyText={t('attributes.options.emptyAdded')}
              listName={['options']}
            />
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};
